import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import {
  mobilePromotion,
  mobilePromotion2,
  promotions,
  promotions2,
} from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromotion} w="100%" alt="Mobile Promotions" />
          <CFImage src={mobilePromotion2} w="100%" alt="Mobile Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px">
          <CFImage src={promotions} w="100%" alt="Promotions" />
          <CFImage src={promotions2} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
